import React, {useState, useEffect} from 'react';
import {Formik, Field, Form} from 'formik';
import {TextField, Loading} from 'components/form';
import {required, validationWrapper, number} from 'lib/formValidations';
import {transformTranslateFromValues} from 'lib/helpers';
import Modal from 'components/Modal'
import {TextArea, Select} from 'components/form';
import {GalleryField} from 'components/form';
import {useCore} from 'store/core'
// components

export default function Add(props) {

    const core = useCore();
    const {show, item} = props

    return (
        <>
            <Modal show={props.show} handleClose={props.close} title={props.title}>
                <Formik
                    initialValues={{}}
                    onSubmit={async (values, {setSubmitting}) => {
                        await props.submit(transformTranslateFromValues(values));
                        props.close();
                        setSubmitting(false);
                    }}
                    enableReinitialize
                >
                    {({isSubmitting, dirty}) => (
                        <Form>
                            <div className="modal-body gap-y-3">
                                <div className="intro-x md:grid md:grid-cols-2 md:gap-3">
                                    <Field
                                        placeholder="نام"
                                        label="نام :"
                                        name="name"
                                        component={TextField}
                                        validate={(value) => validationWrapper(value, required)}
                                    />
                                    <Field
                                        placeholder="name"
                                        label="نام انگلیسی :"
                                        name="_en*name*text"
                                        component={TextField}
                                        validate={(value) => validationWrapper(value, required)}
                                    />
                                    <Field
                                        placeholder="priority"
                                        label="Priority :"
                                        name="priority"
                                        type="number"
                                        component={TextField}
                                        validate={(value) => validationWrapper(value, number)}
                                    />
                                    <Field
                                        label="توضیحات :"
                                        name="desc"
                                        component={TextArea}
                                    />
                                    <Field
                                        label="description"
                                        name="_en*desc*text"
                                        component={TextArea}
                                    />
                                </div>
                            </div>

                            <div className="modal-footer text-right">
                                <button className="btn btn-primary w-20" type="submit"
                                        disabled={!!(isSubmitting || !dirty)}> {isSubmitting ?
                                    <Loading/> : 'ذخیره'}</button>
                                <button type="button"
                                        disabled={isSubmitting}
                                        onClick={props.close} className="btn btn-outline-secondary w-20 mr-1">انصراف
                                </button>
                            </div>

                        </Form>
                    )}
                </Formik>

            </Modal>
        </>
    );
}
